import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { getMainSiteUrl } from '../../lib/getMainSiteUrl';
import { getNormalizeColor } from '../../lib/getNormalizeColor.js';

const FooterLinkWrapper = styled.div `
  width: 100%;
  justify-content: center;
  text-align: center;
  #padding: 5px;
  a {color: ${p=>p.textColor};}
  font-size: ${p=>p.fontSize};
  a:hover {color: ${p=>p.hoverColor};}
`;

const FooterLink = styled.a `
  display: inline-block;
  margin: 10px;
`;

const LinkItem=({link})=>{
  return (
    <FooterLink href={link.href} target="blank">{link.title}</FooterLink>
    );
};

const FooterLinks = ({ textColor='#fff', hoverColor, fontSize="12px", links = [] }) => {
  let footerTextColor = textColor;
  let footerHoverColor = hoverColor || textColor;

  const lpdata = useSelector(state => state.config.lpdata) || {};
  const p = lpdata.properties || {};
  const body = p.body || {};
  const siteLink = getMainSiteUrl(p.header.loginLink);

  if (getNormalizeColor(body.background) === getNormalizeColor(textColor)) {
    footerTextColor = '#7b7b7b';
    footerHoverColor = '#7b7b7b';
  }
  
  const mandatoryPages = [
    {
      title: 'Terms and Conditions',
      href: 'terms'
    },
    {
      title: 'Privacy Policy',
      href: 'privacy'
    },
    {
      title: 'Refund Policy',
      href: 'refund'
    },
    {
      title: '18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement',
      href: '2257'
    }
  ];

  const footerLinks = [];
  
  mandatoryPages.forEach(mandatoryPage => {
    const pageIsPresent = links.length > 0 ? links.some(link => link.href.includes(mandatoryPage.href)) : false;
    if (!pageIsPresent) {
      footerLinks.push({ title: mandatoryPage.title, href: `${siteLink}/en/${mandatoryPage.href}` });
    }
  });

  footerLinks.push(...links);

  return (
    <FooterLinkWrapper textColor={footerTextColor} hoverColor={footerHoverColor} fontSize={fontSize}>
    {footerLinks.map((link,pos) =><LinkItem key={pos} link={link}/>)}
    </FooterLinkWrapper>
  );
};

export default FooterLinks;
